export default __webpack_public_path__ + "static/bad-181d3a979aa2f1c21a8d045419b77afd.png";